import { render, staticRenderFns } from "./login-box.vue?vue&type=template&id=9125f20e"
import script from "./login-box.vue?vue&type=script&lang=js"
export * from "./login-box.vue?vue&type=script&lang=js"
import style0 from "./login-box.vue?vue&type=style&index=0&id=9125f20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../Shield.UI.ProductManagementSystemWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports